import React, { useState, useEffect } from "react";
import axios from "../../features/axiosHelper";
import { Box, Typography } from "@mui/material";

const VersionInfo = () => {
    const [versionInfo, setVersionInfo] = useState({
        major: 0,
        minor: 0,
        patch: 0,
        build: 0,
        buildDate: "",
    });

    useEffect(() => {
        const fetchVersion = async () => {
            try {
                // Create a clean axios instance without auth headers
                const versionClient = axios.create({
                    baseURL: "/api",
                    headers: {
                        // Explicitly remove all unnecessary headers
                        Authorization: undefined,
                        Cookie: undefined,
                    },
                });

                const response = await versionClient.get("/version");
                const [major, minor, patch, build] = response.data.Version.split(".");

                setVersionInfo({
                    major,
                    minor,
                    patch,
                    build,
                    buildDate: response.data.BuildDate,
                });
            } catch (error) {
                console.error("Failed to fetch version:", error);
                // Fallback to default values if API fails
                setVersionInfo({
                    major: 0,
                    minor: 0,
                    patch: 0,
                    build: 0,
                    buildDate: "Unknown",
                });
            }
        };

        fetchVersion();
    }, []);

    return (
        <Box
            sx={{
                color: "var(--neutral-6)",
                mt: 2,
            }}
            title={`Build date: ${versionInfo.buildDate}`}
        >
            <Typography>&copy; {new Date().getFullYear()} Shep Ltd. All rights reserved.</Typography>
            <Typography>
                Version{" "}
                <span style={{ color: "var(--default-light)" }}>
                    {versionInfo.major}.{versionInfo.minor}.{versionInfo.patch} (
                    {versionInfo.build})
                </span>
            </Typography>
        </Box>
    );
};

export default VersionInfo;
